export enum  ConsentType{

    switchPrivacy2 = 'SOCIAL_SECURITY' ,

    EXTERNAL_SERVICES = 'EXTERNAL_SERVICES' ,

    switchPrivacy3 = 'COMMERCIAL_ACTIONS' ,

    switchPrivacy4 = 'THIRD_PARTY_COMMERCIAL_ACTIONS' ,

    DATA_TRANSFER = 'DATA_TRANSFER' ,

    switchPrivacy1 = 'PERSONAL_DATA_PROTECTION' ,

    FINANCIAL_SITUATION = 'FINANCIAL_SITUATION' ,

    ENABLED_DB_PRODUCTS = 'ENABLED_DB_PRODUCTS' ,

    INFORMATION_PRIOR_THIRD_PARTY = 'INFORMATION_PRIOR_THIRD_PARTY' ,

    INFORMATION_PRIOR = 'INFORMATION_PRIOR' ,

    REVOLVING_CARD_CONDITIONS = 'REVOLVING_CARD_CONDITIONS' ,

    REVOLVING_CARD_CONDITIONS_FINALY = 'REVOLVING_CARD_CONDITIONS_FINALY' ,

    ARCO_RIGHTS_LIMITATION = 'ARCO_RIGHTS_LIMITATION' ,

    ARCO_PORTABILITY_RIGHTS = 'ARCO_PORTABILITY_RIGHTS' ,

    VIRTUAL_CARD = 'VIRTUAL_CARD' ,

    OPENBANKING_LEGAL = 'OPENBANKING_LEGAL' ,

    OPENBANKING_ANALISIS = 'OPENBANKING_ANALISIS',

    PERSONAL_DATA_PROTECTION = 'PERSONAL_DATA_PROTECTION'
}